﻿import React, {Component} from 'react';
import RolesDetails from './role-details'
import PropTypes from "prop-types";

class Role extends Component {
    render() {
        return (
            <RolesDetails />
        )
    }
}

Role.contextTypes = {
    router: PropTypes.any.isRequired
};

export default Role;